import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PropagateLoader } from 'react-spinners';
import { PET_TYPES } from '../constants/constants';

import { isValidPassword, isEmail } from '../utils/auth';
import { Dialog, DialogContent } from '@material-ui/core';

const OfferView = props => {
  return (
    <div className='container-fluid hero-container petsure-offer'>
      <div className='row'>
        <div className='home-hero col-md-6 col-md-offset-6 text-center'>
          <div className='hero-content'>
            <div className='consult-type text-center'>
              <div
                className='consult-header'
                style={{ backgroundColor: '#fe9e51', borderColor: '#fe9e51' }}
              >
                <h3>6 Month Membership</h3>
                <div
                  className='consult-price'
                  style={{ backgroundColor: '#f16e1c', borderColor: '#f16e1c' }}
                >
                  <span className='amount'>Petsure</span>
                  <span className='offer'>Exculsive Offer</span>
                </div>
              </div>
              <div className='consult-message'>
                <p>6 month subscription membership</p>
                <p>Pawsonal health record for your pet</p>
                <p>Video or text chat consultations</p>
                <p>Real-time support from a team of trusted Aussie Vets</p>
                <p>
                  Peace of mind, credible answers, clarity on urgency and next
                  steps
                </p>
                <p>Consults between 6am-midnight Sydney Aus time, every day</p>
              </div>
              <div className='consult-purchase'>
                <button
                  className='btn btn-vetchat'
                  onClick={() => {
                    props.setView('subscribe');
                  }}
                >
                  Join Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FormInput = ({ name, type, value, field, setField, disabled }) => {
  return (
    <input
      type={type ? type : 'text'}
      placeholder={name}
      value={value ? value : ''}
      onChange={e => {
        const newValue = e.target.value;
        setField(field, newValue);
      }}
      disabled={disabled}
    />
  );
};

const PetSureOffer = () => {
  const [coupon, setCoupon] = useState({ isValid: false });
  const [couponCode, setCouponCode] = useState(null);
  const [view, setView] = useState('offer');
  const [formData, setFormData] = useState({
    user: {
      firstName: null,
      lastName: null,
      email: null,
      mobile: null,
      password: null,
      confirmPassword: null
    },
    pet: { name: null, type: null, breed: null },
    tc: false
  });
  const [saving, setSaving] = useState(false);
  const [petBreeds, setBreeds] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);

  //component Did Mount
  useEffect(() => {
    async function loadPetBreeds() {
      await axios
        .get('pet/all/breeds')
        .then(res => {
          const sortedBreeds = res.data.sort((a, b) => {
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
              return -1;
            }
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
              return 1;
            }
            return 0;
          });
          setBreeds(sortedBreeds);
        })
        .catch(err => {
          console.log('error getting breeds: ', err);
        });
    }

    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    document.getElementById('main-content').style.margin = '0 0 0';
    loadPetBreeds();

    return () => {
      document.getElementById('main-content').style.margin = '0 0 20px';
    };
  }, []);

  const setField = (field, data) => {
    const fields = field.split('.');
    const currentData = Object.assign({}, formData);
    currentData[fields[0]][fields[1]] = data;
    setFormData(currentData);
  };

  const validateSubscriptionData = async () => {
    setSaving(true);
    const errors = [];

    //checking coupon
    if (!coupon.isValid) {
      errors.push('Need a valid coupon code to continue');
      setErrors(errors);
      return;
    }

    //check email
    if (!isEmail(formData.user.email)) {
      errors.push('Invalid Email address');
    }

    //check password
    if (formData.user.password === null || formData.user.password === '') {
      errors.push('Password is required');
    } else if (!isValidPassword(formData.user.password)) {
      errors.push('Invalid Password');
      errors.push(
        'Password must include at least 8 characters of uppercase and lowercase alphanumeric characters'
      );
    }

    if (
      formData.user.confirmPassword === null ||
      formData.user.confirmPassword === ''
    ) {
      errors.push('Confirm password is required');
    } else if (formData.user.password !== formData.user.confirmPassword) {
      errors.push('Passwords do not match');
    }

    if (formData.user.firstName === null || formData.user.firstName === '') {
      errors.push('First name can not be empty');
    }

    if (formData.user.lastName === null || formData.user.lastName === '') {
      errors.push('Last name can not bLampty');
    }

    if (formData.user.mobile === null || formData.user.mobile === '') {
      errors.push('Phone can not be empty');
    }

    if (formData.pet.name === null || formData.pet.name === '') {
      errors.push('Pet name is required');
    }

    if (formData.type === null || formData.type === '') {
      errors.push('Pet type is required');
    }

    if (
      formData.pet.type &&
      (formData.pet.type === 1 || formData.pet.type === 2) &&
      (formData.pet.breed === null || formData.pet.breed === '')
    ) {
      errors.push('Pet breed is required');
    }

    //check is erros are set
    if (errors.length > 0) {
      setErrors(errors);
      return;
    }

    //NO Errors make axios call to server
    await axios
      .post('/user/offersubscribe', {
        ...formData,
        coupon: { code: coupon.data.code }
      })
      .then(res => {
        // console.log('After Subscription data:', res.data);
        if (res.data.status === false) {
          setErrors([res.data.error]);
        } else {
          setSuccess(true);
        }
      })
      .catch(err => {
        console.log('Error subscribing usign code: \n', err);
        setErrors(['Failed to subscribe, try again.']);
      });

    setTimeout(() => {
      setSaving(false);
    }, 2000);
  };

  const checkCoupon = async () => {
    await axios
      .post('/pay/coupon', { couponCode })
      .then(res => {
        // console.log('coupon response from server', res.data);
        if (res.data === null || res.data.length === 0) {
          setCoupon({
            isValid: false,
            message: (
              <span className='text-danger'>
                <i className='fa fa-times' /> Invalid coupon
              </span>
            )
          });
        } else {
          setCoupon({
            isValid: true,
            message: (
              <span className='text-success'>
                <i className='fa fa-check' /> Coupon applied
              </span>
            ),
            data: res.data
          });
        }
      })
      .catch(err => {
        console.log('Error from coupon on server\n', err);
        //set invlid coupon
        setCoupon({
          isValid: false,
          message: (
            <span className='text-danger'>
              <i className='fa fa-times' /> Invalid coupon
            </span>
          )
        });
      });
  };

  const PetTypeOptions = PET_TYPES.map(type => (
    <option key={`option-type-${type.id}`} value={type.id}>
      {type.name}
    </option>
  ));

  let PetBreedOptions = null;
  if (
    petBreeds.length > 0 &&
    formData.pet.type &&
    (+formData.pet.type === 1 || +formData.pet.type === 2)
  ) {
    const selectedBreeds = petBreeds.filter(
      breed => +breed.species_id === +formData.pet.type
    );

    if (selectedBreeds.length > 0) {
      PetBreedOptions = selectedBreeds.map(breed => (
        <option key={`pet-breed-${breed.id}`} value={breed.id}>
          {breed.name}
        </option>
      ));
    }
  }

  const inputDisabled = !coupon.isValid;

  let breedDisabled = true;
  if (
    (formData.pet.type !== null && formData.pet.type === 1) ||
    formData.pet.type === 2
  ) {
    breedDisabled = false;
  }

  if (!breedDisabled && inputDisabled) {
    breedDisabled = true;
  }

  const listErrors = errors.map((er, index) => (
    <li key={`error-${index}`}>
      <span className='text-danger'>{er}</span>
    </li>
  ));

  const alertClass = errors.length > 0 ? 'alert-warning' : 'alert-success';

  return (
    <div>
      {/* Show Dialog on Errors */}
      <Dialog
        open={errors.length > 0 || success}
        maxWidth={'md'}
        disableBackdropClick={true}
      >
        <DialogContent className={`alert alert-offer ${alertClass}`}>
          {errors.length > 0 && (
            <>
              <h2>Errors Occured</h2>
              <ul>{listErrors}</ul>

              <button
                type='button'
                className='btn btn-transparent'
                onClick={() => {
                  setErrors([]);
                }}
              >
                Clear
              </button>
            </>
          )}

          {success && (
            <>
              <h2>
                {' '}
                <i className='fa fa-check' /> Subscribed Successfuly
              </h2>
              <p className='text-center'>
                <a href='/login' className='btn btn-vetchat'>
                  Login
                </a>
              </p>
            </>
          )}
        </DialogContent>
      </Dialog>

      {view === 'offer' ? (
        <OfferView setView={setView} />
      ) : (
        <div className='form-view offer' style={{ backgroundColor: '#54c4c6' }}>
          <form
            onSubmit={e => {
              e.preventDefault();
              validateSubscriptionData();
            }}
          >
            <div className='col'>
              <div className='coupon'>
                <h3>6 Month Membership</h3>
                <p>Exclusive offer to Petsure</p>
                <div className='coupon-input'>
                  <input
                    type='text'
                    onChange={e => {
                      const newValue = e.target.value;
                      setCouponCode(newValue);
                    }}
                    placeholder='coupon code'
                    onKeyDown={e => {
                      if (e.keyCode === 13) {
                        checkCoupon();
                      }
                    }}
                  />
                  <button
                    type='button'
                    onClick={checkCoupon}
                    className='btn-coupon-check'
                  >
                    <i className='fa fa-chevron-right' />
                  </button>
                </div>
                <div className='coupon-message'>{coupon && coupon.message}</div>
              </div>
              <div>
                <h3 className='block-title'>Login Details</h3>
                <FormInput
                  name='Email'
                  type={'email'}
                  value={formData.user.email}
                  setField={setField}
                  field={'user.email'}
                  disabled={inputDisabled}
                />
                <FormInput
                  name='Password'
                  type={'password'}
                  value={formData.user.password}
                  setField={setField}
                  field={'user.password'}
                  disabled={inputDisabled}
                />
                <FormInput
                  name='Confirm Password'
                  type={'password'}
                  value={formData.user.confirmPassword}
                  setField={setField}
                  field={'user.confirmPassword'}
                  disabled={inputDisabled}
                />
              </div>
            </div>
            <div className='col'>
              <h3 className='block-title'>Your Pet Details</h3>
              <FormInput
                name={`Pet's Name`}
                type={'text'}
                value={formData.pet.name}
                setField={setField}
                field={'pet.name'}
                disabled={inputDisabled}
              />
              <select
                value={formData.pet.type ? formData.pet.type : ''}
                onChange={e => {
                  const newValue = e.target.value;
                  setField('pet.type', +newValue);
                  //remove breed when not cat or dog
                  if (newValue !== 1 || newValue !== 2) {
                    setField('pet.breed', null);
                  }
                }}
                disabled={inputDisabled}
              >
                <option value=''>Pet Type</option>
                {PetTypeOptions}
              </select>
              <select
                value={formData.pet.breed ? formData.pet.breed : ''}
                disabled={breedDisabled}
                onChange={e => {
                  const newValue = e.target.value;
                  setField('pet.breed', newValue);
                }}
              >
                <option value=''>Pet Breed</option>
                {PetBreedOptions}
              </select>
            </div>
            <div className='col'>
              <h3 className='block-title'>Your Personal Details</h3>
              <FormInput
                name='First Name'
                type={'text'}
                value={formData.user.firstName}
                setField={setField}
                field={'user.firstName'}
                disabled={inputDisabled}
              />
              <FormInput
                name='Last Name'
                type={'text'}
                value={formData.user.lastName}
                setField={setField}
                field={'user.lastName'}
                disabled={inputDisabled}
              />
              <FormInput
                name='Email'
                type={'email'}
                value={formData.user.email}
                setField={setField}
                field={'user.email'}
                disabled={inputDisabled}
              />
              <FormInput
                name='Phone'
                type={'text'}
                value={formData.user.mobile}
                setField={setField}
                field={'user.mobile'}
                disabled={inputDisabled}
              />
              <p className='tc-agree'>
                <label className='text-left'>
                  <input
                    type='checkbox'
                    defaultChecked={formData.tc}
                    onChange={e => {
                      const newValue = e.target.checked;
                      setFormData({ ...formData, tc: newValue });
                    }}
                  />
                  <span>
                    You accept our&nbsp;
                    <a href='/terms-and-conditions' target='_blank'>
                      terms and conditions
                    </a>
                    &nbsp;and&nbsp;
                    <a href='/privacy-policy' target='_blank'>
                      privacy policy
                    </a>
                    . We'll ocassionally send account related emails.
                  </span>
                </label>
              </p>
              <div className='text-center' style={{ marginBottom: 20 }}>
                <button
                  className='btn btn-block btn-confirm'
                  disabled={!formData.tc}
                  type='submit'
                >
                  Confirm
                </button>
                <span className='submitting'>
                  {saving && <PropagateLoader color={'#36D7B7'} />}
                </span>
              </div>
            </div>
          </form>
        </div>
      )}
      <div className='offer-tc'>
        <div className='container'>
          <div className='row'>
            <div className='col-xs-12'>
              <p>
                <b>6 MONTH PET INSURANCE MEMBERSHIP SUBSCRIPTION</b>
              </p>
              <p>
                *Offer available to Pet Insurance policy holders, limited to 1
                membership per eligible policy. The 6 months free membership
                offer is from the date of sign up for six months provided your
                pet insurance policy remains active during this time.
              </p>

              <p>
                Vetchat is provided independently by third party service
                provider, Vetchat Services Pty Ltd (Vetchat). Vetchat is not
                able to provide any financial product advice on your Pet
                Insurance policy. Vetchat membership is subject to the
                Vetchat&nbsp;
                <a href='/terms-and-conditions' target='_blank'>
                  Terms and Conditions
                </a>
                &nbsp;and&nbsp;
                <a href='/privacy-policy' target='_blank'>
                  Privacy Policy
                </a>
                .
              </p>

              <p>
                This membership gives you free access to Vetchat services with
                video and text chat to a Veterinarian 6am-midnight AEST/AEDT,
                subject to fair and reasonable use as determined by VETCHAT
                SERVICES PTY LTD.
              </p>

              <p>
                We reserve the right to deny you access to the Website and/or
                the Services at any time at our sole discretion and for any
                reason including, without limitation, if you are in breach of
                these Terms such as with abnormal or excessive use.
              </p>
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetSureOffer;
